import OnePagerStickyReceipt from './OnePagerStickyReceipt'

export default OnePagerStickyReceipt
